import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { BillableRateCopyRequest, BillableRateCreateRequest, BillableRatePatchInBatchRequest, BillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'

class BillableRateService {
    async create(laboratoryId: number, request: BillableRateCreateRequest): Promise<BillableRateResponse> {
        const response =
            await axios.post<BillableRateResponse>(
                `/configuration/laboratories/${laboratoryId}/billableRates`,
                request)
        return response.data
    }

    async copy(laboratoryId: number, request: BillableRateCopyRequest): Promise<BillableRateResponse> {
        const response =
            await axios.post<BillableRateResponse>(
                `/configuration/laboratories/${laboratoryId}/billableRates/copy`,
                request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<BillableRateResponse>> {
        const response =
            await axios.put<IResponseAgGrid<BillableRateResponse>>(
                `/configuration/laboratories/${laboratoryId}/billableRates`,
                { ...filterModel },
                { params })
        return response.data
    }

    async get(laboratoryId: number, billableRateId: number): Promise<BillableRateResponse> {
        const response =
            await axios.get<BillableRateResponse>(
                `/configuration/laboratories/${laboratoryId}/billableRates/${billableRateId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.delete<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/billableRates/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: BillableRatePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.patch<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/billableRates/batch`,
                request)
        return response.data
    }
}
export const billableRateService = new BillableRateService()
